module.exports = __webpack_public_path__ + "img/jim.33eda95c.jpg";